import { byCodeUnit } from "./sort";

/** jsonb's notion of equal: object keys in any order, arrays in order. */
export function sameJsonb(a: unknown, b: unknown): boolean {
  return canonical(a) === canonical(b);
}

/** A value as jsonb compares it: object keys sorted, undefined keys left out, arrays in order. */
export function jsonbCanonical(value: unknown): string {
  return canonical(value);
}

function canonical(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonical).join(",")}]`;
  if (value !== null && typeof value === "object") {
    const record = value as Record<string, unknown>;
    return `{${Object.keys(record)
      .filter((key) => record[key] !== undefined)
      .sort(byCodeUnit)
      .map((key) => `${JSON.stringify(key)}:${canonical(record[key])}`)
      .join(",")}}`;
  }
  return JSON.stringify(value);
}
